module.exports = __webpack_public_path__ + "img/tickets.bc1619bf.svg";